import React from "react";
import Header from "../component/Header";
import { Outlet } from "react-router-dom";

export default function Home() {
  // const navbarMenu = [{ name: "Home" }];
  const navbarMenu = [{ name: "Home", pageNavigate: "/homeCom" }];
  return (
    <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  );
}
